import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import ExpandOutlined from '@mui/icons-material/ExpandOutlined';
import type { ButtonProps } from '@mui/material/Button';

export interface ExpandCollapseAllButtonProps
  extends Omit<ButtonProps, 'children'> {
  tooltipLabel?: string;
  expanded: boolean;
  disableTooltip?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default function ExpandCollapseAllButton({
  tooltipLabel,
  expanded = false,
  disableTooltip = false,
  onClick,
  ...rest
}: ExpandCollapseAllButtonProps) {
  const theme = useTheme();

  const buttonContent = (
    <span>
      <Button
        {...rest}
        onClick={onClick}
        sx={{
          justifyContent: 'flex-start',
          textTransform: 'none',
          textDecoration: 'underline',
          py: 0.5,
          color: theme.palette.semantic.hyperlink.active,
          fontSize: '14px',
          minWidth: 112,
        }}
        startIcon={<ExpandOutlined sx={{ width: 14, height: 14 }} />}
      >
        {expanded ? 'Collapse All' : 'Expand All'}
      </Button>
    </span>
  );

  if (disableTooltip || !tooltipLabel) {
    return buttonContent;
  }

  return (
    <Tooltip arrow title={tooltipLabel || ''}>
      {buttonContent}
    </Tooltip>
  );
}
